import Button from 'Components/Base/Button'
import Column from 'Components/Base/Column'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import FlipCard from 'Components/FlipCard'
import EnrollmentConfirmation from 'Pages/Enrollment/Confirmation/EnrollmentConfirmation'
import ScheduleCards from 'Pages/ScheduleCards/ScheduleCards'
import { StyledPageContainer } from 'Styles/global'
import { sizes } from 'Styles/sizes'
import { useAppSelector } from 'hooks/hooks'
import React, { useEffect, useState } from 'react'
import { useAuth } from 'react-oauth2-pkce'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { getAccessToken } from 'reducers/authSlice'
import styled, { useTheme } from 'styled-components'
import image3 from '../../Assets/Images/Health Insurance-13 1.png'
import image1 from '../../Assets/Images/Med Review-03 1.png'
import image2 from '../../Assets/Images/Phone Call-23 1.png'
import image4 from '../../Assets/Images/Pill Money-27 1.png'
import './AppointmentPage.scss'
import Calendar from './components/Calendar/Calendar'
import CTLLifestyle from './components/Lifestyle/CTLLifestyle'
import { useNavigate } from 'react-router-dom'

export default function AppointmentPage() {
  const navigate = useNavigate()
  useEffect(() => {
    if (!token) {
      navigate('/')
    }
  }, [])

  const [isMobile, setIsMobile] = useState<boolean>(false)
  const theme = useTheme()
  const auth = useAuth()

  const setMobileSetting = () => {
    if (window.innerWidth < 800) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  useEffect(() => {
    setMobileSetting()
    window.addEventListener('resize', () => {
      setMobileSetting()
    })
  }, [])

  const token = useAppSelector(getAccessToken)
  const [step, setStep] = useState(1)
  const [ctl, setCtl] = useState(false)
  const [isInitial, setIsInitial] = useState(false)
  const [cardId, setCardId] = useState<number | null>(null)

  const renderContent = () => {
    switch (step) {
      case 1:
        return (
          <ScheduleCards
            handleSetStep={(step: number, isInitial: boolean, cardId: number) => {
              setIsInitial(isInitial)
              setStep(step)
              setCardId(cardId)
            }}
            handleSetCtl={(ctl: boolean) => setCtl(ctl)}
          />
        )
      case 2:
        return <Calendar ctl={ctl} handleSubmit={() => (isInitial && ctl && cardId === 8 ? setStep(4) : setStep(3))} isInitial={isInitial} />
      case 3:
        return <EnrollmentConfirmation ctl={ctl} isInitial={isInitial} />
      case 4:
        return (
          <CTLLifestyle
            handleSubmit={() => {
              setIsInitial(true)
              setStep(3)
            }}
          />
        )
    }
  }

  return token ? (
    <StyledContainer>{renderContent()}</StyledContainer>
  ) : (
    <StyledPage>
      <>
        <Column>
          <img
            src="https://triacentral.blob.core.windows.net/dev-storage/portal/images/Pharmacist%20Phone%20Call-28%201.png"
            className="appointment-banner-image"
            alt="Man writing on calendar"
            style={isMobile ? {} : { width: '50%', marginLeft: 'auto' }}
          />

          <div className="appointment-form">
            <div className="appointment-header-container"></div>
            <h1 className="appointment-header">Schedule an</h1>
            <h1 className="appointment-subheader">Appointment</h1>
            <Typography styles={{ margin: '40px 0px', width: isMobile ? '100%' : '472px', textAlign: isMobile ? 'center' : 'left' }} size={22}>
              Click below to schedule a private phone consultation with a Tria Health pharmacist. You can also use our{' '}
              <span style={{ color: theme.colors.primary1, textDecoration: 'underline' }}>
                <a rel="noreferrer" href="https://medchatapp.com/widget/60qB-Pr0gEeAOYuH7bhHNw/chat">
                  live chat
                </a>
              </span>{' '}
              to book your appointment.
            </Typography>

            <StyledButton
              pageName="pre_login_appointment"
              text="Pharmacist Consult"
              className="new-patient-btn"
              backgroundColor={theme.colors.primary1}
              styles={{ width: isMobile ? '100%' : '400px' }}
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_AUTH_REGISTER_URL}?returnUrl=${window.location.origin}`
              }}
            />
            <Typography styles={{ marginTop: '5px', marginBottom: '20px', width: isMobile ? '100%' : '472px' }} size={22}>
              Already a member?{' '}
              <span style={{ color: theme.colors.primary1, textDecoration: 'underline', cursor: 'pointer' }} onClick={() => auth.authService.login()}>
                Click here to login
              </span>
            </Typography>
            <StyledButton
              pageName="pre_login_appointment"
              text="Weight Loss Coaching"
              className="ctl-sign-up-btn"
              hoverColor={theme.colors.status.good}
              backgroundColor={theme.colors.status.good}
              styles={{
                width: isMobile ? '100%' : '400px',
              }}
              onClick={() => (window.location.href = 'https://medchatapp.com/widget/6oB2rB9OOEeKolPuwfNjLw/chat')}
            />
          </div>
          <Row>
            <ResponsiveContainer styles={{ width: isMobile ? '100%' : '83vw', justifyContent: 'space-between', marginTop: 50 }}>
              <FlipCard
                isMobile={isMobile}
                side1={
                  <Typography
                    size={18}
                    color="white"
                    styles={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                  >
                    Your pharmacist will review all your meds: prescription, over-the counter, vitamins and/or supplements
                  </Typography>
                }
                side2={
                  <div style={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <img src={image1} alt="medication" style={{ margin: '12px 0px' }} />
                    <Typography font="bold" size={22}>
                      Review
                    </Typography>
                    <Typography font="bold" size={22} styles={{ marginTop: -5 }}>
                      Medications
                    </Typography>
                  </div>
                }
              />
              <FlipCard
                isMobile={isMobile}
                side1={
                  <Typography
                    size={18}
                    color="white"
                    styles={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                  >
                    Talk with a medication expert and get answers for all your questions!
                  </Typography>
                }
                side2={
                  <div style={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <img src={image2} alt="medication" style={{ margin: '10px 0px 5px', height: 120 }} />
                    <Typography font="bold" size={22} styles={{ margin: 'auto' }}>
                      Get Answers
                    </Typography>
                  </div>
                }
              />
              <FlipCard
                isMobile={isMobile}
                side1={
                  <Typography
                    size={18}
                    color="white"
                    styles={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                  >
                    Your Tria pharmacist will coordinate any recommendations directly with your doctor(s).
                  </Typography>
                }
                side2={
                  <div style={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <img src={image3} alt="medication" style={{ margin: '10px 0px 5px' }} />
                    <Typography font="bold" size={22} styles={{ margin: 'auto' }}>
                      Coordinate Care
                    </Typography>
                  </div>
                }
              />
              <FlipCard
                isMobile={isMobile}
                side1={
                  <Typography
                    size={18}
                    color="white"
                    styles={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                  >
                    You may be missing out on medication savings! Let our pharmacists help.
                  </Typography>
                }
                side2={
                  <div style={{ margin: 0, position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <img src={image4} alt="medication" style={{ margin: '10px 0px 5px' }} />
                    <Typography font="bold" size={22} styles={{ margin: 'auto' }}>
                      Save Money
                    </Typography>
                  </div>
                }
              />
            </ResponsiveContainer>
          </Row>
        </Column>
      </>
    </StyledPage>
  )
}

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 45px;
  width: 96%;
  text-align: center;
  min-height: 600px;
  margin-left: 2%;
  margin-right: 2%;
  @media ${sizes.laptop} {
    margin-left: 10%;
    margin-right: 10%;
    width: 80%;
  }
`
export const StyledPage = styled(StyledPageContainer)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 10px;
  @media ${sizes.laptop} {
    flex-direction: row;
  }
`
export const StyledButtonRow = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 50px;
  @media ${sizes.laptop} {
    flex-direction: row;
  }
`

const StyledButton = styled(Button)`
  font-family: 'Raleway-Semi-Bold';
  font-size: 22px;
  padding-top: 10px;
  width: 100%;
  padding: 10px 0px;
  border-radius: 0px;
`
